<template>
  <div class="password-reset with-background"></div>
</template>

<script>
export default {
  name: "PasswordReset",
  mounted: function() {
    if (this.isLoggedIn) {
      this.$router.push("/");
      return;
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
